import React from 'react';
import Navbar from '../Ui/Navbar';
import bitcoinHero from '../../Assets/Hero/bicoinhero.png';
import { useLanguage } from '../../App';

const Hero = () => {
  const { t, language } = useLanguage();
  const isRTL = language === 'ar';
  
  const scrollToServices = (e) => {
    e.preventDefault();
    const target = document.getElementById('services');
    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;
    const duration = 800; 

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = (t, b, c, d) => {
        t /= d;
        return -c * t * (t - 2) + b;
      };
      window.scrollTo(0, run(timeElapsed, startPosition, distance, duration));
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }
    requestAnimationFrame(animation);
  };

  const getColoredTitle = (text) => {
    const targetEn = "crypto currency";
    const targetAr = "العملات المشفرة";
    
    if (text.includes(targetEn)) {
      const parts = text.split(targetEn);
      return <>{parts[0]}<span style={{ color: '#1A4D90' }}>{targetEn}</span>{parts[1]}</>;
    }
    if (text.includes(targetAr)) {
      const parts = text.split(targetAr);
      return <>{parts[0]}<span style={{ color: '#1A4D90' }}>{targetAr}</span>{parts[1]}</>;
    }
    return text;
  };

  return (
    <div 
      id="home"
      dir={isRTL ? 'rtl' : 'ltr'}
      className={`w-full font-alexandria overflow-hidden relative pt-[80px] lg:pt-[100px] ${isRTL ? 'text-right' : 'text-left'}`}
    >
      <div className="absolute inset-0 w-full h-full z-[-1]"
        style={{
          background: isRTL 
            ? 'radial-gradient(20% 20% at 70% 30%, #005BEC 0%, #0049BE 0%, #003385 0%, #002155 10%, #030B15 100%)'
            : 'radial-gradient(20% 20% at 30% 30%, #005BEC 0%, #0049BE 0%, #003385 0%, #002155 10%, #030B15 100%)',
          backgroundBlendMode: 'screen'
        }}
      ></div>
      
      <Navbar />

      <div className="max-w-[1440px] mx-auto w-full relative">
        <div className={`
          relative w-full px-6 md:px-12 lg:px-[104px]
          flex flex-col lg:flex-row 
          justify-between items-center
          /* التعديلات هنا للايباد */
          min-h-fit 
          md:h-auto          /* تم إلغاء الارتفاع الثابت 500px في الايباد */
          md:py-12          /* إضافة مساحة عمودية بسيطة بدلاً من الارتفاع الكبير */
          lg:h-[550px] 
          xl:h-[calc(100vh-100px)] 
          py-12 lg:py-0
          gap-8
        `}>
          
          <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start z-20">
            <div className={`w-full max-w-[656px] text-center lg:text-${isRTL ? 'right' : 'left'}`}>
              <h1 className={`
                font-bold 
                text-[30px] sm:text-[40px] md:text-[38px] lg:text-[52px] xl:text-[68px]
                ${isRTL ? 'leading-[1.4] lg:leading-[1.3] font-arabic' : 'leading-[1.2] lg:leading-[1.1]'}
                text-white mb-8
              `}>
                {getColoredTitle(t('hero.title'))}
              </h1>
              
              <div className={`flex flex-col sm:flex-row gap-4 justify-center lg:justify-start`}>
                <button 
                  onClick={scrollToServices}
                  className="w-full sm:w-auto min-w-[160px] h-[52px] lg:h-[60px] rounded-[10px] text-white font-medium text-[16px] lg:text-[18px] relative overflow-hidden group px-8 flex items-center justify-center transition-transform hover:scale-105 active:scale-95 shadow-lg"
                  style={{ background: 'radial-gradient(50% 50% at 50% 50%, #1A4D90 0%, #0C2341 100%)' }}
                >
                  <div className={`absolute inset-0 ${isRTL ? 'bg-gradient-to-l' : 'bg-gradient-to-r'} from-[#1A4D90] to-[#2A7DE1] opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                  <span className="relative z-10">{t('buttons.getStarted')}</span>
                </button>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end items-center order-first lg:order-none z-10">
            <div className="relative w-full max-w-[240px] sm:max-w-[300px] md:max-w-[320px] lg:max-w-[550px] xl:max-w-[650px]">
              <img 
                src={bitcoinHero} 
                alt="Bitcoin Hero" 
                className={`w-full h-auto object-contain transition-transform duration-1000 animate-pulse-slow hover:scale-105`}
                style={{ filter: 'drop-shadow(0 0 30px rgba(26, 77, 144, 0.4))' }}
              />
            </div>
          </div>

        </div>
      </div>
      
      {isRTL && (
        <div className="absolute inset-0 z-[-1] pointer-events-none opacity-20"
          style={{ background: 'linear-gradient(to left, rgba(0, 43, 108, 0.2) 0%, transparent 50%)' }}
        ></div>
      )}
    </div>
  );
};

export default Hero;